import React, { FC } from 'react';
import { Stack, Typography } from '@mui/material';

type Props = {
  title?: string;
  children?: React.ReactNode;
};

const SettingsBlock: FC<Props> = ({ title, children }) => {
  return (
    <Stack direction="column" gap={1}>
      {title ? (
        <Typography fontWeight={700} fontSize={18} color="primary">
          {title}
        </Typography>
      ) : null}
      {children}
    </Stack>
  );
};

export default SettingsBlock;
